<template>
  <div>
    <invoice-list :filters="filters"></invoice-list>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import InvoiceList from 'src/views/admin/administration/invoices/InvoiceList';
  export default {
    name: 'client-management-invoices',
    components: {
      InvoiceList
    },
    computed: {
      ...mapState({
        client: state => state.client.currentClient
      }),
      invoices() {
        if(!this.client) {
          return [];
        }
        return this.client.invoices ? this.client.invoices : [];
      },
      filters() {
        return [
          {
            key: 'match[client_uuid]',
            value: this.$route.params.id
          },
          {
            key: 'with',
            value: 'client'
          }
        ]
      }
    }
  }
</script>
<style>
</style>
